import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from './Hero.jsx';
import HomeProductsShowcase from './HomeProductsShowcase';
import ServiceGrid from './ServiceGrid.jsx';
import AboutUs from './AboutUs.jsx';
import FAQ from './FAQ.jsx';
import LocationNewsletter from './LocationNewsletter.jsx';
import { scrollToSection } from '../utils/scrollUtils';

const HomeContainer: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const sectionId = (location.state as any)?.scrollTo;
    if (sectionId) {
      // Dar un pequeño delay para asegurar que los componentes estén montados
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 150);
    }
  }, [location.state]);

  return (
    <>
      <Hero />
      <HomeProductsShowcase />
      <ServiceGrid />
      <AboutUs />
      <FAQ />
      <LocationNewsletter />
    </>
  );
};

export default HomeContainer;